import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, AtSign, MapPin, Clock, Zap } from 'lucide-react';
import { BRAND, HOURS } from '../utils/constants';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              THE <span>FHYSIQUE</span> FACTORY
            </div>
            <p>Transforming bodies and lives in Kingston, Jamaica since 2021.</p>
            <div className="footer-social">
              <a
                href={`https://wa.me/${BRAND.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="social-btn whatsapp"
              >
                WhatsApp
              </a>
              <a
                href={BRAND.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="social-btn instagram"
              >
                Instagram
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/packages">Packages</Link></li>
              <li><Link to="/schedule">Schedule</Link></li>
              <li><Link to="/contact">Contact & Book</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <ul>
              <li>
                <a href={`tel:${BRAND.phone}`}>
                  <Phone size={14} /> {BRAND.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={BRAND.instagramUrl} target="_blank" rel="noopener noreferrer">
                  <AtSign size={14} /> @{BRAND.instagram}
                </a>
              </li>
              <li>
                <a href={BRAND.mapsUrl} target="_blank" rel="noopener noreferrer">
                  <MapPin size={14} /> {BRAND.locationShort}
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Hours</h4>
            <ul>
              {HOURS.map((h) => (
                <li key={h.day} className="hours-item">
                  <Clock size={14} />
                  <span><strong>{h.day}</strong><br />{h.time}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} The Fhysique Factory. Kingston, Jamaica.</p>
          <p className="footer-disclaimer">
            EST. {BRAND.est} · Transforming 500+ Lives
          </p>
        </div>

        {/* ── IronLogic AI branding ── prominent section */}
        <div className="ironlogic-section">
          <div className="ironlogic-inner">
            <div className="ironlogic-left">
              <div className="ironlogic-logo">
                <Zap size={18} fill="var(--black)" color="var(--black)" />
                <span>IronLogic AI</span>
              </div>
              <p className="ironlogic-tagline">
                Website, booking system &amp; automation built by IronLogic AI.
              </p>
            </div>
            <div className="ironlogic-right">
              <p className="ironlogic-pitch">Want a site like this for your business?</p>
              <a href="https://ironlogic.ai" target="_blank" rel="noopener noreferrer" className="ironlogic-cta">
                Let's build it — ironlogic.ai →
              </a>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
}
